<template>
  <FormBase @submit="save">
    <template #title>Billing Details</template>

    <div class="form-group row required">
      <label class="col-xl-3 col-lg-3 col-form-label">
        Address Line 1
      </label>
      <div class="col-lg-9 col-xl-6">
        <input
          v-model="form.address_line_1"
          class="form-control"
          :class="{ 'is-invalid': hasError('address_line_1') }"
          @input="clearError('address_line_1')"
        />
        <div v-if="hasError('address_line_1')" class="invalid-feedback">
          {{ getError("address_line_1") }}
        </div>
      </div>
    </div>

    <div class="form-group row">
      <label class="col-xl-3 col-lg-3 col-form-label">
        Address Line 2
      </label>
      <div class="col-lg-9 col-xl-6">
        <input
          v-model="form.address_line_2"
          class="form-control"
          :class="{ 'is-invalid': hasError('address_line_2') }"
          @input="clearError('address_line_2')"
        />
        <div v-if="hasError('address_line_2')" class="invalid-feedback">
          {{ getError("address_line_2") }}
        </div>
      </div>
    </div>

    <div class="form-group row required">
      <label class="col-xl-3 col-lg-3 col-form-label">
        City
      </label>
      <div class="col-lg-9 col-xl-6">
        <input
          v-model="form.city"
          class="form-control"
          :class="{ 'is-invalid': hasError('city') }"
          @input="clearError('city')"
        />
        <div v-if="hasError('city')" class="invalid-feedback">
          {{ getError("city") }}
        </div>
      </div>
    </div>

    <div class="form-group row required">
      <label class="col-xl-3 col-lg-3 col-form-label">
        State
      </label>
      <div class="col-lg-9 col-xl-6">
        <input
          v-model="form.state"
          class="form-control"
          :class="{ 'is-invalid': hasError('state') }"
          @input="clearError('state')"
        />
        <div v-if="hasError('state')" class="invalid-feedback">
          {{ getError("state") }}
        </div>
      </div>
    </div>

    <div class="form-group row required">
      <label class="col-xl-3 col-lg-3 col-form-label">
        Postal Code
      </label>
      <div class="col-lg-9 col-xl-6">
        <input
          v-model="form.postal_code"
          class="form-control"
          :class="{ 'is-invalid': hasError('postal_code') }"
          @input="clearError('postal_code')"
        />
        <div v-if="hasError('postal_code')" class="invalid-feedback">
          {{ getError("postal_code") }}
        </div>
      </div>
    </div>

    <div class="form-group row required">
      <label class="col-xl-3 col-lg-3 col-form-label">
        Country
      </label>
      <div class="col-lg-9 col-xl-6">
        <select
          v-model="form.country"
          class="form-control"
          :class="{ 'is-invalid': hasError('country') }"
          @input="clearError('country')"
        >
          <option>Select Country</option>
          <option
            v-for="country in countries"
            :key="country.code"
            :value="country.code"
          >
            {{ country.name }}
          </option>
        </select>

        <div v-if="hasError('country')" class="invalid-feedback">
          {{ getError("country") }}
        </div>
      </div>
    </div>
  </FormBase>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import FormBase from "./-FormBase.vue";
import ValidationErrorsMixin from "@/mixins/ValidationErrors.js";

export default {
  name: "BillingDetailsForm",
  components: {
    FormBase,
  },

  mixins: [ValidationErrorsMixin],

  data() {
    return {
      form: {
        address_line_1: "",
        address_line_2: "",
        city: "",
        state: "",
        country: "",
        postal_code: "",
      },
      busy: false,
    };
  },

  computed: {
    ...mapGetters({
      user: "auth/user",
      countries: "country/countries",
    }),
  },

  mounted() {
    this.form = {
      address_line_1: this.user.address_1,
      address_line_2: this.user.address_2,
      city: this.user.city,
      state: this.user.state,
      country: this.user.country_code,
      postal_code: this.user.postal_code,
    };

    if (!this.countries.length) {
      this.getCountries();
    }
  },

  methods: {
    ...mapActions({
      getCountries: "country/get",
      update: "auth/updateBillingAddress",
    }),

    save() {
      if (this.busy) {
        return;
      }
      this.busy = true;

      this.update(this.form)
        .then(() => {
          this.$swal({
            icon: "success",
            title: "Upload successful!",
            text: "Your billing address updated successfully.",
          });
        })
        .catch((error) => {
          if (error.response?.status === 422) {
            this.errors = error.response.data.errors;
          }
        })
        .finally(() => (this.busy = false));
    },
  },
};
</script>
